import UISelectorItem from "../views/_commons/Selector/UISelectorItem";


export const PAGE_START          = 0;
export const PAGE_DELETE_ACCOUNT = 1;
export const PAGE_VILLAGE        = 2;
export const PAGE_IMPRESSUM      = 3;
export const PAGE_DATENSCHUTZ    = 4;
export const PAGE_AGB            = 5;
export const PAGE_CONTACT        = 6;

export const PAGES = [
    {
        id: '#/start',
        path : '/home',
        name : "Dorffuchs - Gemeinde erleben. Gemeinsam gestalten",
        index : PAGE_START,
        showInMenu: 'never',
        requiresLogin: false
    },
    {
        id: '#/konto-entfernen',
        path : '/delete-account',
        name : "Konto entfernen",
        index: PAGE_DELETE_ACCOUNT,
        showInMenu: 'never',
        requiresLogin: false
    },
    {
        id: '#/gemeinde',
        path : '/gemeinde',
        name : "Gemeinde",
        index: PAGE_VILLAGE,
        showInMenu: 'never',
        requiresLogin: false
    },
    {
        id: '#/impressum',
        path : '/impressum',
        name : "Dorffuchs - Impressum",
        index: PAGE_IMPRESSUM,
        showInMenu: 'never',
        requiresLogin: false
    },
    {
        id: '#/datenschutz',
        path : '/datenschutz',
        name : "Dorffuchs - Datenschutz",
        index: PAGE_DATENSCHUTZ,
        showInMenu: 'never',
        requiresLogin: false
    },
    {
        id: '#/agb',
        path : '/agb',
        name : "Dorffuchs - AGB",
        index: PAGE_AGB,
        showInMenu: 'never',
        requiresLogin: false
    },
    {
        id: '#/contact',
        path : '/contact',
        name : "Dorffuchs - Kontakt",
        index: PAGE_CONTACT,
        showInMenu: 'never',
        requiresLogin: false
    }
];

export const TIME_UNITS = [
    // {
    //     id: 'Minutes',
    //     name: 'Minuten'
    // },
    {
        id: 'Hours',
        name: 'Stunden'
    },
    {
        id: 'Days',
        name: 'Tage'
    },
    {
        id: 'Years',
        name: 'Jahre'
    }
];


export const USER_LOCK_DURATION_TYPES = [
    {
        id: 'forever',
        name: 'Permanent'
    },
    {
        id: 'temporary',
        name: 'Temporär'
    }
];



export const REJECT_REASONS = [
    new UISelectorItem("1","Sprache / Orthographie"),
    new UISelectorItem("2","Beleidigung"),
    new UISelectorItem("3","Urheberrecht"),
    new UISelectorItem("4","Falschbehauptung"),
    new UISelectorItem("other","Sonstiges")
];

export const FORUM_CONTENT_STATUS_REVIEW_REQUIRED  = 'ModerationRequired';
export const FORUM_CONTENT_STATUS_CONTENT_REJECTED = 'ContentRejected';

export const FORUM_CONTENT_DRAFT_STATE_DRAFT                 = 'Draft';
export const FORUM_CONTENT_DRAFT_STATE_PUBLICATION_REQUESTED = 'PublicationRequested';
export const FORUM_CONTENT_DRAFT_STATE_CHANGE_ACCEPTED       = 'ChangeAccepted';
export const FORUM_CONTENT_DRAFT_STATE_CHANGE_REJECTED       = 'ChangeRejected';

export const USER_ACTION_ERROR_OCCURRED = 'USER_ACTION_ERROR_OCCURRED';

export const USER_ACTION_SUBVIEW_SELECTED = 'USER_ACTION_SUBVIEW_SELECTED';

export const USER_ACTION_DO_LOGIN = 'USER_ACTION_DO_LOGIN';
export const USER_ACTION_EDIT_CITY = 'USER_ACTION_EDIT_CITY';
export const USER_ACTION_SHOW_CITY_CHANGE_HISTORY = 'USER_ACTION_SHOW_CITY_CHANGE_HISTORY';
export const USER_ACTION_CITY_LIST_VIEW_TYPE_CHANGED = 'USER_ACTION_CITY_LIST_VIEW_TYPE_CHANGED';
export const USER_ACTION_CLOSE_CITY_INFO_DIALOG = 'USER_ACTION_CLOSE_CITY_INFO_DIALOG';
export const USER_ACTION_COLLECT_CONTEXT_DATA = 'USER_ACTION_COLLECT_CONTEXT_DATA';

export const USER_ACTION_PUBLISH_CITY_CHANGES = 'USER_ACTION_PUBLISH_CITY_CHANGES';

export const USER_ACTION_ERROR_VIEW_OK_CLICKED = 'USER_ACTION_ERROR_VIEW_OK_CLICKED';

//


export const USER_ACTION_CLOSE_AUTHORITY_EDIT_DIALOG = 'USER_ACTION_CLOSE_AUTHORITY_EDIT_DIALOG';

export const VIEW_STATE_UPDATE_ACTION  = "VIEW_STATE_UPDATE_ACTION";

export const VIEW_STATE_LOADING  = "VIEW_STATE_LOADING";
export const VIEW_STATE_NO_DATA_AVAILABLE  = "VIEW_STATE_NO_DATA_AVAILABLE";
export const VIEW_STATE_ERROR    = "VIEW_STATE_ERROR";
export const VIEW_STATE_USER_CONFIRMATION    = "VIEW_STATE_USER_CONFIRMATION";
export const VIEW_STATE_DONE     = "VIEW_STATE_DONE";
export const VIEW_STATE_SAVE_IN_PROGRESS    = "VIEW_STATE_SAVE_IN_PROGRESS";
export const VIEW_STATE_AWAIT_USER_ACTION     = "VIEW_STATE_AWAIT_USER_ACTION";

export const BROADCAST_ACTION_DATA_SAVED = 'BROADCAST_ACTION_DATA_SAVED';
export const BROADCAST_USER_ACTION_EXECUTED = 'BROADCAST_USER_ACTION_EXECUTED';

export const MIN_PASSWORD_LENGTH = 5;
